var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCompaniesList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 80,
    viewBox: "0 0 97 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5634_66326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5705 77.2079C16.4271 69.6137 10.6476 45.7417 17.5598 28.4358C25.2262 9.24546 46.1294 4.08348 49.7225 3.27464C62.2192 0.454923 84.0433 0.890237 92.6871 15.2219C102.294 31.1516 88.5347 52.496 79.0463 62.1207C76.5577 64.6455 54.4427 86.4534 33.5705 77.2079Z",
    fill: "#ECF3FE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5634_66326)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M68.7938 2.23145L18.998 9.85244C18.998 9.85244 27.2528 45.548 43.2805 79.7718L93.0762 72.1561C77.0486 37.927 68.7938 2.23145 68.7938 2.23145Z",
    fill: "#3A7EC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.098 67.2326C77.5462 33.7631 68.401 0.000244141 68.401 0.000244141L18.998 9.84731C18.998 9.84731 28.1485 43.6102 45.6951 77.0797L95.098 67.2326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7781 26.362C38.6284 26.362 41.7497 23.2407 41.7497 19.3905C41.7497 15.5402 38.6284 12.4189 34.7781 12.4189C30.9279 12.4189 27.8066 15.5402 27.8066 19.3905C27.8066 23.2407 30.9279 26.362 34.7781 26.362Z",
    fill: "#3B82F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7952 17.0545L35.9564 17.6254L35.3854 14.7812L32.4418 15.3731L33.0127 18.212L30.1738 18.7829L30.7605 21.7266L33.6046 21.1556L34.1755 23.9945L37.1139 23.4079L36.543 20.5638L39.3871 19.9929L38.7952 17.0545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6132 10.8635L44.253 15.3522C43.5407 15.4937 42.844 15.0327 42.6974 14.3152C42.5559 13.6028 43.0169 12.9062 43.7345 12.7595L66.0946 8.27598C66.807 8.13456 67.5036 8.59549 67.6502 9.31306C67.7917 10.0254 67.3307 10.722 66.6132 10.8635Z",
    fill: "#B3CEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6581 17.1016L46.2979 21.5904C45.5856 21.7318 44.8889 21.2709 44.7423 20.5533C44.6009 19.841 45.0618 19.1443 45.7794 18.9977L68.1395 14.5089C68.8519 14.3675 69.5485 14.8284 69.6952 15.546C69.8366 16.2636 69.3704 16.9602 68.6581 17.1016Z",
    fill: "#B3CEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9546 32.9461L33.1299 36.7225C32.4176 36.864 31.721 36.403 31.5743 35.6855C31.4329 34.9731 31.8938 34.2765 32.6114 34.1298L51.4361 30.3534C52.1484 30.212 52.845 30.6729 52.9917 31.3905C53.1279 32.108 52.6669 32.8047 51.9546 32.9461Z",
    fill: "#B3CEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.773 28.7716L68.3995 29.6463C67.6871 29.7878 66.9905 29.3268 66.8439 28.6093C66.7024 27.8969 67.1634 27.2003 67.8809 27.0536L72.2545 26.1737C72.9668 26.0323 73.6635 26.4932 73.8101 27.2108C73.9515 27.9283 73.4854 28.625 72.773 28.7716Z",
    fill: "#B3CEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1266 34.9153L70.753 35.7953C70.0406 35.9367 69.344 35.4758 69.1974 34.7582C69.0559 34.0458 69.5169 33.3492 70.2345 33.2026L74.608 32.3226C75.3203 32.1812 76.017 32.6421 76.1636 33.3597C76.3051 34.072 75.8441 34.7687 75.1266 34.9153Z",
    fill: "#B3CEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5445 41.0435L73.171 41.9234C72.4586 42.0649 71.762 41.6039 71.6153 40.8864C71.4739 40.174 71.9348 39.4774 72.6524 39.3307L77.026 38.4508C77.7383 38.3094 78.4349 38.7703 78.5816 39.4879C78.723 40.2054 78.2621 40.9021 77.5445 41.0435Z",
    fill: "#B3CEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5704 59.2815L80.5264 60.2924C79.8141 60.4338 79.1175 59.9729 78.9708 59.2553C78.8294 58.543 79.2903 57.8464 80.0079 57.6997L85.0519 56.6888C85.7642 56.5474 86.4609 57.0083 86.6075 57.7259C86.7489 58.4435 86.2828 59.1401 85.5704 59.2815Z",
    fill: "#B3CEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0842 40.1375L35.4659 42.8716C34.7535 43.013 34.0569 42.5521 33.9103 41.8345C33.7688 41.1222 34.2298 40.4256 34.9473 40.2789L48.5656 37.5448C49.278 37.4034 49.9746 37.8643 50.1212 38.5819C50.2627 39.2994 49.7965 39.9961 49.0842 40.1375Z",
    fill: "#B3CEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1226 45.7417L37.9483 48.9892C37.236 49.1306 36.5393 48.6697 36.3927 47.9521C36.2513 47.2397 36.7122 46.5431 37.4298 46.3965L53.6041 43.149C54.3164 43.0076 55.0131 43.4685 55.1597 44.1861C55.3011 44.9037 54.8402 45.6003 54.1226 45.7417Z",
    fill: "#B3CEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8042 56.2332L43.2022 61.1672C42.4899 61.3086 41.7932 60.8477 41.6466 60.1301C41.5052 59.4178 41.9661 58.7212 42.6837 58.5745L67.2856 53.6405C67.998 53.4991 68.6946 53.96 68.8412 54.6776C68.9827 55.3951 68.5217 56.0865 67.8042 56.2332Z",
    fill: "#B3CEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5606 64.3047L46.0362 67.2169C45.3239 67.3584 44.6272 66.8974 44.4806 66.1799C44.3391 65.4675 44.8001 64.7709 45.5177 64.6242L60.0421 61.712C60.7544 61.5706 61.451 62.0315 61.5977 62.7491C61.7391 63.4614 61.273 64.1581 60.5606 64.3047Z",
    fill: "#3B82F4"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M86.1157 50.5553C91.9753 50.5553 96.7255 45.8325 96.7255 40.0066C96.7255 34.1808 91.9753 29.458 86.1157 29.458C80.256 29.458 75.5059 34.1808 75.5059 40.0066C75.5059 45.8325 80.256 50.5553 86.1157 50.5553Z",
    fill: "#4A7CB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0649 50.5553C90.9245 50.5553 95.6747 45.8325 95.6747 40.0066C95.6747 34.1808 90.9245 29.458 85.0649 29.458C79.2052 29.458 74.4551 34.1808 74.4551 40.0066C74.4551 45.8325 79.2052 50.5553 85.0649 50.5553Z",
    fill: "#F49E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2267 45.0789C81.8454 45.0424 81.4781 44.8599 81.2154 44.5425L78.3483 41.0741C77.8229 40.4393 77.9162 39.5013 78.5545 38.9789C79.1929 38.4566 80.1364 38.5492 80.6618 39.1839L82.577 41.5038L88.5428 36.631C89.1812 36.1087 90.1247 36.2013 90.6501 36.8361C91.1755 37.4708 91.0823 38.4088 90.4439 38.9312L83.3227 44.7475C83.0035 45.0087 82.608 45.1155 82.2267 45.0789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8573 4.8699C57.2098 4.8699 58.3063 3.77974 58.3063 2.43495C58.3063 1.09016 57.2098 0 55.8573 0C54.5047 0 53.4082 1.09016 53.4082 2.43495C53.4082 3.77974 54.5047 4.8699 55.8573 4.8699Z",
    fill: "#4A7CB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7682 35.3011C11.0043 34.2235 10.317 33.1598 9.2332 32.9251C8.1494 32.6904 7.07944 33.3737 6.8434 34.4512C6.60736 35.5288 7.29462 36.5926 8.37843 36.8273C9.46224 37.0619 10.5322 36.3787 10.7682 35.3011Z",
    fill: "#4A7CB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6053 70.1333C82.9579 70.1333 84.0544 69.0432 84.0544 67.6984C84.0544 66.3536 82.9579 65.2634 81.6053 65.2634C80.2527 65.2634 79.1562 66.3536 79.1562 67.6984C79.1562 69.0432 80.2527 70.1333 81.6053 70.1333Z",
    fill: "#4A7CB8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5634_66326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.732,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5634_66326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.1,
    height: 79.7717,
    fill: "white",
    transform: "translate(19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCompaniesList);
export default __webpack_public_path__ + "static/media/active-companies-list.223a712c651f07d92d89204548c5a058.svg";
export { ForwardRef as ReactComponent };